"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialTags = void 0;
var SpecialTags;
(function (SpecialTags) {
    SpecialTags["NONE"] = "none";
    SpecialTags["INFLUENCE"] = "influence-count";
    SpecialTags["CITY_COUNT"] = "city-count";
    SpecialTags["COLONY_COUNT"] = "colony-count";
    SpecialTags["UNDERGROUND_TOKEN_COUNT"] = "underground-token-count";
    SpecialTags["CORRUPTION"] = "corruption-count";
    SpecialTags["NEGATIVE_VP"] = "negative-vp";
})(SpecialTags || (exports.SpecialTags = SpecialTags = {}));
